import { render, staticRenderFns } from "./LittleAssistantSection.vue?vue&type=template&id=4c400ce2&scoped=true"
import script from "./LittleAssistantSection.vue?vue&type=script&lang=js"
export * from "./LittleAssistantSection.vue?vue&type=script&lang=js"
import style0 from "./LittleAssistantSection.vue?vue&type=style&index=0&id=4c400ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c400ce2",
  null
  
)

export default component.exports